import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  deleteMalwareDetectionError,
  deleteMalwareDetectionSuccess,
  getMalwareDetectionsError,
  getMalwareDetectionsSuccess,
  updateMalwareDetectionError,
  updateMalwareDetectionSuccess,
} from './actions'
import {
  DELETE_MALWARE_DETECTION_ASYNC,
  GET_MALWARE_DETECTIONS_ASYNC,
  UPDATE_MALWARE_DETECTION_ASYNC,
} from './constants'

const malwareDetectionsKeys = ['opswat', 'vxstream', 'paloalto', 'gradient']

const getMalwareDetectionsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      GET_MALWARE_DETECTIONS_ASYNC.INITIATE,
      UPDATE_MALWARE_DETECTION_ASYNC.SUCCESS,
      DELETE_MALWARE_DETECTION_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.malware)
      return true
    })
    .mergeMap(() =>
      Observable.forkJoin(
        malwareDetectionsKeys.map((key) =>
          api.settings
            .getMalwareDetection(store.getState().partnerOptions.selectedCompany?.value, key)
            .map((response) => getMalwareDetectionsSuccess({ name: key, data: response }))
            .catch((error) =>
              Observable.of(epicsErrorHandler(getMalwareDetectionsError, error, [400]))
            )
            .takeUntil(action$.ofType(GET_MALWARE_DETECTIONS_ASYNC.CANCEL))
        )
      )
    )
    .mergeMap((actions) => actions.map((action) => store.dispatch(action)))

const updateMalwareDetectionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_MALWARE_DETECTION_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .updateMalwareDetection(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.name,
        action.payload.data
      )
      .mergeMap((response) => {
        window.closeModal()
        return Observable.of(
          updateMalwareDetectionSuccess(response),
          addToast({ message: 'Successfully integrated!' })
        )
      })
      .catch((error) => Observable.of(epicsErrorHandler(updateMalwareDetectionError, error)))
      .takeUntil(action$.ofType(UPDATE_MALWARE_DETECTION_ASYNC.CANCEL))
  )

const deleteMalwareDetectionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_MALWARE_DETECTION_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .deleteMalwareDetection(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.name
      )
      .map((response) => deleteMalwareDetectionSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(deleteMalwareDetectionError, error)))
      .takeUntil(action$.ofType(DELETE_MALWARE_DETECTION_ASYNC.CANCEL))
  )

export default combineEpics(
  getMalwareDetectionsEpic,
  updateMalwareDetectionEpic,
  deleteMalwareDetectionEpic
)
